var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.selected_menu)?_c('HeadBanner',{attrs:{"itemData":_vm.$store.state.selected_menu}}):_vm._e(),_c('Breadcrumb'),_c('HighlightsTabs',{attrs:{"itemData":_vm._.get(this.$store.state.indx, 'terms.financial_highlights_category')}}),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.HighlightsList.conf.enabled'
      ) == 1
    )?_c('HighlightsList',{attrs:{"itemData":_vm._.get(
        this.$store.state.current_content,
        'secondary.HighlightsList.data'
      )}}):_vm._e(),_c('div',{staticClass:"policiesListContainer container"},[_c('div',{staticClass:"policiesListInner mt-144"},[(
          _vm._.get(
            this.$store.state.current_content,
            'secondary.PoliciesList.conf.enabled'
          ) == 1
        )?_c('PoliciesDownloadList',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.PoliciesList')}}):_vm._e(),(
          _vm._.get(
            this.$store.state.current_content,
            'secondary.PoliciesBanner.conf.enabled'
          ) == 1
        )?_c('PoliciesBanner',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.PoliciesBanner')}}):_vm._e()],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }